import { FlySvgSprite } from '@fly/svg';

type Translate = (key: string, options: { defaultValue: string }) => string;

export function getDistributionStatusItems(t: Translate) {
  return [
    {
      value: 'not_allow',
      label: (
        <FlySvgSprite
          name='not_allow'
          size={16}
          aria-label={t(
            'app.dashboard.artifacts.distribution_form.status.not_allowed_aria_label',
            {
              defaultValue: 'Not allowed',
            }
          )}
          className='text-slate-12 w-8'
        />
      ),
    },
    {
      value: 'distribution',
      label: (
        <FlySvgSprite
          name='distribution'
          size={16}
          aria-label={t(
            'app.dashboard.artifacts.distribution_form.status.distribution_aria_label',
            {
              defaultValue: 'Distribution',
            }
          )}
          className='text-slate-12 w-8'
        />
      ),
    },
  ] as const;
}
